<template>
<update-base>
    <div v-if="enabled_stakeholders.length == 0">
        <div class="alert alert-warning" v-text="$t('stakeholders.label.add_stakeholder_to_shop_notice')"></div>
    </div>
    <div v-else>
        <div v-if="has_error" v-text="error_text" class="alert alert-danger mb-4"></div>
        <div v-if="is_updated" class="alert alert-success mb-4" v-text="successful_update_text"></div>
        <div class="row">
            <div class="col-12 col-md-6">
                <label for="add_stakeholder" v-text="$t('stakeholders.label.add_stakeholder_to_allotment')"></label>
                <select id="add_stakeholder"
                        name="add_stakeholder"
                        v-model="new_stakeholder"
                        class="form-control kt-selectpicker">
                    <option v-for="(item, index) in enabled_stakeholders" :key="index" :value="item">
                        <span>{{ item.full_name }} ({{ item.id }})</span>
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-3">
            <div>
                <button type="button"
                        class="btn btn-primary mr-3"
                        v-text="$t('btn.add')"
                        data-toggle="modal"
                        data-target="#add_new_allotment_modal"
                        :disabled="new_stakeholder == null">
                </button>
                <button type="button"
                        class="btn btn-success"
                        @click="submit_allotment()"
                        v-text="$t('btn.submit_changes')">
                </button>
            </div>
            <div>
                <button type="button"
                        class="btn btn-danger"
                        @click="delete_allotments()"
                        v-text="$t('btn.delete_all')">
                </button>
            </div>
        </div>
        <div class="line-divider mt-4 mb-3"></div>
        <div class="text-center">
            <table class="table">
                <thead>
                    <tr>
                        <th v-text="$t('label.identifier')"></th>
                        <th v-text="$t('label.full_name')"></th>
                        <th v-text="$t('label.sheba_number')"></th>
                        <th v-text="$t('label.percent')"></th>
                        <th v-text="$t('datatable.actions')"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in allotments" :key="index">
                        <td v-text="item.id"></td>
                        <td v-text="item.full_name"></td>
                        <td v-text="item.sheba_number.number"></td>
                        <td v-text="item.percent"></td>
                        <td>
                            <button type="button" class="btn btn-sm p-1 my-0 mx-2 btn-danger" @click="deleteRow(index)">
                                <i class="la la-trash-o p-0"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="add_new_allotment_modal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <form @submit.prevent="add_new_allotment()" id="add_new_stakeholder_form">
                            <div v-if="new_stakeholder != null" class="row">
                                <div class="col-12 col-md-9 my-2">
                                    <label for="sheba" v-text="$t('label.sheba_number')"></label>
                                    <select id="sheba"
                                            name="sheba"
                                            v-model="new_sheba_details"
                                            class="form-control">
                                        <option v-for="(item, index) in new_stakeholder.sheba_numbers" :key="index" :value="item">
                                            <span v-text="item.number"></span>
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3 my-2">
                                    <label for="percent" v-text="$t('label.percent')"></label>
                                    <input  id="percent"
                                            type="number"
                                            name="percent"
                                            v-model="new_percent"
                                            class="form-control">
                                </div>
                            </div>
                            <div>
                                <button type="button" class="mx-2 btn btn-secondary" data-dismiss="modal" v-text="$t('label.cancel')"></button>
                                <button type="submit" class="mx-2 btn btn-primary" v-text="$t('btn.add')"></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</update-base>
</template>

<script>
import UpdateBase from './components/allotment-update-base';
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { stakeholdersService, allotmentService } from '@/common/api.service';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { allotmentStatus } from '@/constants/AllotmentStatus';

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            is_updated: false,
            successful_update_text: '',
            allotment_status: allotmentStatus,
            has_error: false,
            error_text: '',
            allotments: [],
            enabled_stakeholders: [],
            new_stakeholder: null,
            new_sheba_details: {
                id: null,
                number: '',
            },
            new_percent: 1,
            merchant_type: merchantType,
            merchant_type_str: merchantTypeStr,
        };
    },
    computed: {
        sum_of_percents() {
            let result = 0;

            for (let i = 0; i < this.allotments.length; ++i) {
                result += this.allotments[i].percent;
            }

            return result;
        }
    },
    methods: {
        delete_allotments() {
            let delete_all = window.confirm(i18n.t('message.delete_all_allotment_confirm'));

            if (delete_all) {
                this.allotments = [];
            }
        },
        submit_allotment() {
            let allotments = [];

            for (let i = 0; i < this.allotments.length; ++i) {
                allotments.push({
                    related_merchant_id: this.allotments[i].id,
                    percent: this.allotments[i].percent,
                    sheba_number_id: this.allotments[i].sheba_number.id,
                });
            }

            let params = {
                'allotments': allotments,
                'allotment_status': allotments.length > 0 ? this.allotment_status.ACTIVE : this.allotment_status.INACTIVE,
            };

            allotmentService.update_dedicated(this.$route.params.hashid, params).then(response => {
                this.successful_update_text = response.data.message;
                this.has_error = false;
                this.is_updated = true;
            }).catch(error => {
                this.is_updated = false;
                this.error_text = i18n.t('message.an_error_occurred');
                this.has_error = true;
            });
        },
        add_new_allotment() {
            if (this.new_stakeholder != null && this.new_stakeholder != '') {
                let form = $('#add_new_stakeholder_form');

                form.validate({
                    rules: {
                        percent: {
                            required: true,
                            min: 1,
                            max: () => {
                                return (99 - this.sum_of_percents);
                            },
                        },
                        sheba: {
                            required: true,
                        },
                    },
                });

                if (!form.valid()) {
                    form.off('.validate').removeData('validator').removeData("unobtrusiveValidation");
                    return;
                }
                form.off('.validate').removeData('validator').removeData("unobtrusiveValidation");

                if (this.allotments.length >= 9) {
                    this.error_text = i18n.t('stakeholders.error.max_allowed_stakeholders_for_allotment_list_are_nine');
                    this.has_error = true;
                    $('#add_new_allotment_modal').modal('toggle');
                    return;
                }

                for (let i = 0; i < this.allotments.length; ++i) {
                    if (this.allotments[i].id == this.new_stakeholder.id
                        && this.allotments[i].sheba_number.number == this.new_sheba_details.number
                    ) {
                        this.error_text = i18n.t('stakeholders.error.cant_add_stakeholder_again');
                        this.has_error = true;
                        $('#add_new_allotment_modal').modal('toggle');
                        return;
                    }
                }

                this.has_error = false;
                this.error_text = '';

                this.allotments.push({
                    full_name:          this.new_stakeholder.full_name,
                    id:                 this.new_stakeholder.id,
                    sheba_number:       this.new_sheba_details,
                    percent:            parseInt(this.new_percent),
                });

                $('#add_new_allotment_modal').modal('toggle');

                // reset
                this.new_sheba_details = {
                    id: null,
                    number: '',
                };
                this.new_percent = 1;
            }
        },
        deleteRow(index) {
            this.allotments.splice(index, 1);
        },
        init_select_picker() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }
    },
    mounted() {
        stakeholdersService.get_dedicated_shop_enabled_stakeholders(this.$route.params.hashid).then(response => {
            this.enabled_stakeholders = response.data.data;

            allotmentService.fetch_dedicated(this.$route.params.hashid).then(response => {
                this.allotments = response.data.data;
            });
        }).finally(() => {
            this.init_select_picker();
        });
    },
}
</script>
